export enum WellplateTimestampTypes {
    UNKNOWN = 0,
    DATE_RECEIVED = 10,
    DATE_DUE = 20,
    DATE_STORAGE_REQUESTED = 30,
    DATE_STORED = 40,
    DATE_STORAGE_EXPIRES = 50,
    DATE_DISPOSAL_SCHEDULED = 60,
    DATE_DISPOSAL_REQUESTED = 70,
    DATE_DISPOSED = 80,
    DATE_RETURN_REQUESTED = 90,
    DATE_RETURNED = 100,
}
